import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Auth.css';

const WEBSITE_SIGNUP_URL = process.env.REACT_APP_WEBSITE_SIGNUP_URL || 'https://www.slpmicrosystems.com/signup';

const AuthLanding = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode'); // 'login' | 'signup'

  // If mode is specified, redirect to the appropriate page
  React.useEffect(() => {
    if (mode === 'signup') {
      window.location.href = WEBSITE_SIGNUP_URL;
    } else if (mode === 'login') {
      navigate('/login', { replace: true });
    }
  }, [mode, navigate]);

  // If no mode, show the choice page
  if (mode) {
    return null; // Will redirect
  }

  return (
    <div className="auth-page-wrapper auth-landing-wrapper">
      <div className="auth-container auth-landing-container">
        <div className="auth-landing-card auth-card">
          <div className="auth-header">
            <h1>CloudFish</h1>
            <p>Log in or create an account to continue</p>
          </div>
          <div className="auth-landing-buttons">
            <button
              type="button"
              className="auth-btn auth-btn-primary auth-btn-block"
              onClick={() => navigate('/login')}
            >
              Log in
            </button>
            <a
              href={WEBSITE_SIGNUP_URL}
              className="auth-btn auth-btn-outline auth-btn-block"
              style={{ textAlign: 'center', textDecoration: 'none' }}
            >
              Sign up
            </a>
          </div>
          <p className="auth-landing-hint">
            New user? Sign up to create an account. Already have an account? Log in.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLanding;
